<app-form
  [title]="'Datos del demandante persona natural'"
  [fields]="formFields"
  [withSubmitButton]="withSubmitButton"
  (changeAction)="onChanges($event)"
  (submitAction)="onSubmit($event)">
</app-form>
